var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isBreadcrumbLoading
    ? _c("b-skeleton", {
        attrs: { type: "input", height: "3rem", animation: "fade" }
      })
    : !_vm.isShowingNotFoundPage && _vm.breadcrumbItemList.length > 0
    ? _c("div", [
        _c("div", { staticClass: "menu-breadcrumb" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-12",
                  attrs: {
                    itemscope: "",
                    itemtype: "https://schema.org/BreadcrumbList"
                  }
                },
                _vm._l(_vm.breadcrumbItemList, function(item) {
                  return _c(
                    "span",
                    {
                      key: item.url,
                      attrs: {
                        itemprop: "itemListElement",
                        itemscope: "",
                        itemtype: "https://schema.org/ListItem"
                      }
                    },
                    [
                      item.showSeparator
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "breadcrumb-link breadcrumb-link-not-last",
                              attrs: {
                                to: item.url,
                                title: item.title,
                                itemprop: "item"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "d-none",
                                attrs: { itemprop: "id" },
                                domProps: { textContent: _vm._s(item.url) }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                attrs: { itemprop: "name" },
                                domProps: { textContent: _vm._s(item.title) }
                              })
                            ]
                          )
                        : _c(
                            "router-link",
                            {
                              staticClass:
                                "breadcrumb-link breadcrumb-link-last",
                              attrs: {
                                to: _vm.$route.fullPath,
                                title: item.title,
                                itemprop: "item"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "d-none",
                                attrs: { itemprop: "id" },
                                domProps: { textContent: _vm._s(item.url) }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                attrs: { itemprop: "name" },
                                domProps: { textContent: _vm._s(item.title) }
                              })
                            ]
                          ),
                      _vm._v(" "),
                      _c("meta", {
                        attrs: { itemprop: "position", content: item.position }
                      }),
                      _vm._v(" "),
                      item.showSeparator
                        ? _c("span", { staticClass: "link-separator" }, [
                            _c("div", { staticClass: "icon-arrow arrow-right" })
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }